
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';
import { PersonType } from 'src/app/services/models/enums';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogProps,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { WalletTrackingRegistryResponseInnerOutputDto } from 'src/generated-sources/openapi/wallet-service/tracking-registry';
import { NO_NAME } from '../../constants';
import { TrackingRegistryView } from 'src/app/views/list-individual/services/list-individual.facade';

type IDocumentWalletsDialogProps = TrackingRegistryView;

@Component({
  selector: 'app-document-wallets-modal',
  templateUrl: './document-wallets-modal.component.html',
  styleUrls: ['./document-wallets-modal.component.scss'],
  imports: [SharedModule, MatDialogModule, ConfirmationDialogComponent],
})
export class DocumentWalletsModalComponent implements OnDestroy {
  name: string;
  document: string;
  wallets: WalletTrackingRegistryResponseInnerOutputDto[] = [];
  personType = PersonType.COMPANY;

  private readonly subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: IDocumentWalletsDialogProps,
    public dialogRef: MatDialogRef<DocumentWalletsModalComponent>,
    private readonly globalService: GlobalServiceService,
  ) {
    this.subscription = this.globalService.getPersonType$().subscribe((type) => {
      this.personType = type;
    });

    if (data) {
      this.name = data.name || NO_NAME;
      this.document = data.document;
      this.wallets = data.wallets;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handleClose() {
    this.dialogRef.close();
  }

  get confirmationDialogProps(): ConfirmationDialogProps {
    return {
      title: $localize`:@@wallets:Carteras`,
      cancelButton: {
        hide: true,
      },
    };
  }
}
